<template>
  <div class="km-scroll">
    <div class="km-flex-list">
      <div v-for="choice in choices" :key="choice.id" class="km-choice">
        <div :class="cssFinal(choice)" class="km-choice-date km-padding">
          <div v-if="pollType == 1" class="date-details">
            <div class="km-flex-day">
              {{ weekDay(choice) }}
            </div>
            <div class="km-dayMonth">
              {{ dayMonth(choice) }}
            </div>
            <div
              v-if="hasTimerange(choice) && choice.start != choice.end"
              class="km-timeRange"
            >
              <span v-if="choice.start">{{ choice.start | timeRange }}</span>
              <span v-else>-</span>
              <span v-if="choice.end">-{{ choice.end | timeRange }}</span>
            </div>
            <div v-else class="km-timeRange">
              <span>-</span>
            </div>
          </div>
          <div
            v-if="hasText(choice)"
            :class="cssChoice(choice.id)"
            class="km-text"
          >
            {{ choice.text | textComment }}
          </div>
        </div>

        <div
          class="choice-answer-new-design-parent light-mode light-mode-bg-ff"
        >
          <div class="km-padding choice-answer-new-design-child">
            <div
              v-if="showCounts"
              class="answers-details"
              @click="openModalOfUserDataForChoice(choice.id)"
            >
              <div v-if="0" class="dis-label">{{ $t('polls.total') }}</div>
              <div class="count-column">
                <div class="km-answers-count pointer text-weight-semi-bold">
                  <div class="km-accepted mr-1">
                    <div class="d-flex align-self-center">
                      <font-awesome-icon :icon="['fas', 'check']" />
                    </div>
                    <div class="d-flex align-self-center">
                      <div class="ml-2">
                        {{ countYesAnswers(choice) }}
                        <span v-if="showLimitCount(choice)"
                          >/{{ votesChoiceLimit(choice) }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <div v-if="0" class="km-not-accepted">
                    <div class="d-flex align-self-center">
                      <font-awesome-icon :icon="['fas', 'times']" />
                    </div>
                    <div class="d-flex align-self-center">
                      <div class="ml-3">
                        {{ countNoAnswers(choice) }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="km-not-accepted text-size-14"
                    v-if="!isHiddenParticipantMode"
                  >
                    <!-- <div
                    class="text-size-12 text-underline"
                  > -->
                    <!-- {{ $t('polls.viewTrend') }} -->
                    <!-- </div> -->
                    <font-awesome-icon :icon="['fas', 'info-circle']" />
                  </div>
                </div>
              </div>
            </div>

            <div class="render-preference px-1 justify-content-center">
              <RenderNameOfQuestion
                :isLimitReached="isLimitReached(choice)"
                :value="getAnswerForChoice(participant, choice)"
                :poll="poll"
                :isCnetered="false"
              />

              <div 
              :class="colAligmentCss"
              class="details-column ">
                <div
                  class="render-choices justify-content-start "
                  :class="{ 'form-border': showFormBox(participant, choice) }"
                >
                  <renderPreference
                    :value="getAnswerForChoice(participant, choice)"
                    :loading="isLoading(participant, choice.id)"
                    :isEditable="isEditable(participant)"
                    :isDisabled="isDisabled(participant, choice)"
                    :isLimitReached="isLimitReached(choice)"
                    :isCurrentUser="isCurrentUser"
                    :preference="getPreferenceForChoice(participant, choice.id)"
                    :showEditButton="showEditButton"
                    :showAnswers="!showEditButton"
                    :isMobile="true"
                    @editedChoice="onEditedChoice"
                    @click.native="
                      toggleChoiceIfEnabled($event, participant, choice)
                    "
                    :isDesktopMode="false"
                  />
                </div>
                <RenderDescriptionOfAnswer
                  v-if="
                    showDescriptionOfAnswer(choice) "
                  :participant="participant"
                  :choice="choice"
                />

                <RenderAnswerSelection
                  v-if="showDescriptionOfAnswer()"
                  :participant="participant"
                  :choice="choice"
                  :isCentered="false"
                />
              </div>
            </div>
          </div>

          <!-- config answer drop down -->
          <div v-if="0" class="choice-data">
            <template v-if="!showEditButton">
              <div
                class="choice-custom-answer mb-2"
                v-for="(answer, index) in findAllWhichMatchesChoiceAnswer(
                  participant,
                  choice
                )"
                :key="answer.id"
              >
                <span class="option-label">
                  {{ answer.config.labelValue }}
                </span>
                <span class="option-answer">
                  {{
                    getPreferenceAnswerValueForDisplay(
                      participant,
                      choice.id,
                      index
                    )
                  }}
                </span>
              </div>
            </template>
            <template v-else>
              <div
                class="mb-2"
                v-for="(answer, index) in findAllWhichMatchesChoiceAnswer(
                  participant,
                  choice
                )"
                :key="answer.id"
              >
                <template v-if="answer.isReadonly">
                  <div class="px-2 choice-custom-answer mb-2">
                    <span class="option-label">
                      {{ answer.config.labelValue }}
                    </span>
                    <span class="option-answer">
                      {{
                        getAdminAnswerWhenUserIsNotAllowed(
                          answer.config,
                          choice,
                          index
                        )
                      }}
                    </span>
                  </div>
                </template>
                <template v-else>
                  <InputSelectField
                    :label="answer.config.labelValue"
                    :options="
                      answer.config.values.map((option) => option.value)
                    "
                    :value="getPreferenceAnswer(participant, choice, index)"
                    @select="
                      onSelectOptions($event, participant, choice.id, index)
                    "
                  />
                </template>
              </div>
            </template>
          </div>
          <!-- config answer drop down end -->
        </div>
        <!-- @toggle="toggleChoice($event, participant, choice.id)" -->
      </div>
    </div>
    <ModalParticipantInfoDialog
      ref="dlgPaymentDialog"
      :participants="userData"
      :isOwner="isOwner"
    >
    </ModalParticipantInfoDialog>
    <ModalChoiceDialog
      ref="dlgChoiceDialog"
      :editedChoice="editedChoice"
      @selectChoice="onSelectChoice"
    />
  </div>
</template>
<script>
import ModalChoiceDialog from './ModalChoiceDialog';

import renderPreference from './RenderPreference';
import { renderMixin } from '../mixins/RenderMixins';

import { mapState, mapGetters } from 'vuex';
import RenderNameOfQuestion from './RenderNameOfQuestion.vue';
import RenderDescriptionOfAnswer from './RenderDescriptionOfAnswer.vue';
import RenderAnswerSelection from './RenderAnswerSelection.vue';

export default {
  name: 'MobileParticipantsChoices',
  props: [
    'pollType',
    'choices',
    'participant',
    'isCurrentUser',
    'showEditButton',
    'loading',
    
  ],
  mixins: [renderMixin],

  data() {
    return {
      userData: [],
      dlgChoiceDialog: null,
      editedChoice: {
        posX: 50,
        posY: 50,
      },
    };
  },

  components: {
    renderPreference,
    ModalChoiceDialog,
    RenderNameOfQuestion,
    RenderDescriptionOfAnswer,
    RenderAnswerSelection,
  },

  methods: {
    votesChoiceLimit(choice) {
      console.info(
        'votesChoiceLimit',
        this.poll.options.votesLimit,
        this.poll.options.votesLimitSpecific
      );
      if (
        !(
          this.poll.options.limitedVotesPerChoice ||
          this.poll.options.limitedVotesPerChoiceSpecific
        )
      )
        return 256;
      if (this.poll.options.limitedVotesPerChoice) {
        return this.poll.options.votesLimit;
      }
      return choice.limit;
    },

    showFormBox(participant, choice) {
      if (this.isBookingMode && !this.isOwner) {
        if (this.participantBackup) {
          let preferenceForChoice = this.participantBackup.preference_list.find(
            (preference) => preference.choice_id === choice.id
          );
          if (preferenceForChoice.value >= 0) return false;
        }
      }
      if (this.isLimitReached(choice)) {
        const value = this.getAnswerForChoice(participant, choice);
        if (value < 1) return false;
      }
      return this.showEditButton;
    },

    toggleChoiceIfEnabled($event, participant, choice) {
      // if( this.submittingParticipant != participant) return false;
      if (
        this.isDisabled(participant, choice) ||
        this.showEditButton == false ||
        this.loading
      ) {
        return;
      }
      this.toggleChoice($event, participant, choice);
      this.$emit('toggle');
    },
    onEditedChoice(data) {
      this.editedChoice = data;
      console.log('onEditedChoice', this.editedChoice);
    },

    cssFinal(choice) {
      if (this.poll.closed && choice.final) return 'bg-closed';
      if (this.isLimitReached(choice)) return 'bg-completed';
    },

    isChecked(index = 0) {
      // console.log('isChecked:', participant, index);
      //let value = participant.preferences[index].value === 1;
      // console.log('isChecked:', participant, index, value);
      let value = index % 2;
      return value;
    },

    hasTimerange(choice) {
      const date = new Date(choice.start);
      if (date.getHours() === 0 && date.getMinutes() === 0) {
        if (choice.end == null) {
          return false;
        }
      }
      return true;
    },

    hasText(choice) {
      if (!choice.text) return false;
      if (choice.text == '-') return false;
      return true;
    },
    openModalOfUserDataForChoice(choiceId) {
      if (this.isHiddenParticipantMode) return;
      this.userData = this.getAllParticipantOfChoice(choiceId);
      // let description = "<ul>"
      // for (var i = 0; i < userData.length; i++) {
      //   description += "<li>" + userData[i].name + "-" + userData[i].email + "-" + userData[i].choice +"</li>"
      // }
      // description += "</ul>";
      // this.dialogContent.description = description;
      this.$nextTick(() => {
        this.$refs.dlgPaymentDialog.openModal();
      });
    },
    updateAnswer($event, participant, choiceId) {
      console.log('toggle answer ==> ', { value: $event, choiceId: choiceId });
      this.$emit('toggle', {
        value: $event.newValue,
        originalValue: $event.originalValue,
        participant: participant,
        choice_id: choiceId,
      });
    },
    isLimitReached(choice) {
      return this.isChoiceVotesLimitReached(0, choice);
    },
    showDescriptionOfAnswer(choice) {
      if (choice && this.isLimitReached(choice)) {    // Andi - do not show description for full
        return false;
      }
      //show description only in edit mode
      return this.showEditButton;
    },
  },
  computed: {
    ...mapState({
      userId: (state) => state.Login.userId,
      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
    }),
    ...mapGetters({
      isAdmin: 'isAdmin',
    }),

    colAligmentCss()  {
      const isCentered = false;
      if( isCentered ) {
        return 'align-items-center';
      }
        return 'align-items-end';
    }
  },
  mounted() {
    this.dlgChoiceDialog = this.$refs.dlgChoiceDialog;
    // console.error("MobileParticipantChoice dlgChoiceDialog:",this.dlgChoiceDialog);
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  flex-direction: column;
  display: flex;
}

li {
  margin: 0em;
  padding: 0em;
}

.km-choice-list {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.km-choice {
  // padding: 14px;
  border-top: 1px solid $grid-border;
  display: flex;
  flex: 1;
  flex-direction: row;
  // justify-content: space-between;
  align-items: stretch;
  padding: 0px;
  outline: 0px solid orange;
  outline-offset: -1px;
  width: 100%;
}

.km-not-accepted {
  display: flex;
  flex-wrap: nowrap;
  flex-grow: 1;
  flex-direction: row;
}

.km-accepted {
  display: flex;
  color: $checked-color;
}

.km-answers-count {
  align-items: center;
  font-size: $standard;
  // flex-direction: column;
  width: 100%;
  display: flex;
}

.km-answers-icon {
  width: 20px;
  /* display: flex;  */
}

.km-choice-date {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  padding: 0.3em;
  flex-shrink: 0;
  flex-grow: 0;
  outline: 0px solid green;
  outline-offset: -3px;
}

.km-flex-day {
  font-weight: 700;
  font-size: 16px;
  flex: 1;
}

.km-text {
  font-weight: 600;
  font-size: 14px;
  flex: 1;
  text-align: center;
  width: 140px;
}

.date-details {
  width: 140px;
}

@media (min-width: 360px) {
  .km-text {
    width: 130px;
  }

  .date-details {
    width: 130px;
  }
}

.km-dayMonth {
  font-weight: 700;
  font-size: 28px;
  flex: 1;
}

.km-timeRange {
  white-space: nowrap;
  font-size: 16px;
  flex: 1;
}

.km-participant-choices {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}

.km-padding {
  padding: 0.3em;
  box-sizing: border-box;
}

.render-choices {
  display: flex;
}

.form-border {
  border: 1px solid;
  border-radius: 3px;
  padding: 0px;
  margin: 0px;
  // width: 42px;
  // height: 42px;
  width: 48px;
  height: 48px;
  background-color: $white;
  color: $dark-grey;
  margin-top: 5px;
}

.choice-answer-new-design-parent {
  // text-align: -webkit-center;
  width: 100%;
  align-items: stretch;
  box-sizing: border-box;
  overflow-x: hidden;
  display: flex;

  .choice-answer-new-design-child {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: stretch;
    .answers-details {
      width: 125px;
      align-items: stretch;
      display: flex;
    }
  }
}

.option-answer {
  word-wrap: break-word;
  font-weight: $semi-bold-weight;
  font-size: $standard;
}
.option-label {
  word-wrap: break-word;
  font-size: $very-small;
  font-weight: $regular-weight;
}

.choice-data {
  text-align: right;
}

.render-choices-block {
  width: 60%;
}

.dis-label {
  font-size: $so-small;
  font-weight: $regular-weight;
  text-align: left;
}

.choice-custom-answer {
  display: grid;
  line-height: 15px;
}

::v-deep .v-select {
  margin-top: 0px !important;
}

.invert-color {
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.bg-completed {
  background-color: $complete-color;
}

.render-preference {
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  box-sizing: border-box;
}

.form-border-height {
  height: 48px;
}

.choice-response-description {
  text-align: center;
  font-size: $so-small;
  min-height: 20px;
}

.count-column {
  display: flex;
  align-items: center;
}

.details-column {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
